import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
// import Header from "../components/Header";
import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import LatestEventsSection from "./LatestEventsSection";
import SocialFeedSection from "./SocialFeedSection";
import PartnersSection from "./PartnersSection";
import MembersCarouselSection from "./MembersCarouselSection";
import MembershipSection from "./MembershipSection";
import FooterSection from "./FooterSection";
import EmiratesIntroSection from "./EmiratesIntroSection";
import Vision2031Section from "./Vision2031Section";
import ObjectivesSection from "./ObjectivesSection";
import VisionMissionValuesSection from "./VisionMissionValuesSection";
import ManufacturersSection from "./ManufacturersSection";
import ProductsSection from "./ProductsSection";
import BenefitsSection from "./BenefitsSection";
import LabelHowToSection from "./LabelHowToSection";
import StrategicPartnersSection from "./StrategicPartnersSection";
import StrategicPartnersShowcase from "./StrategicPartnersShowcase";
import NewsStoriesSection from "./NewsStoriesSection";
import ContactUsSection from "./ContactUsSection";
import AcknowledgmentSection from "./AcknowledgmentSection";
import FooterNoteSection from "./FooterNoteSection";

const setMeta = (title, description) => {
  if (title) document.title = title;
  if (description) {
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);
  }
};

const Home = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const enTitle = 'Emirates Made – Proudly Made in the Emirates';
    const arTitle = 'صنع الإمارات – فخورون بصُنع الإمارات';
    const enDesc = 'Official UAE initiative celebrating locally made products, innovation and national industry excellence.';
    const arDesc = 'المبادرة الرسمية لدعم المنتجات والخدمات المصنّعة محلياً وتعزيز التميّز الصناعي الإماراتي.';
    const isAr = (i18n.language || 'en').startsWith('ar');
    setMeta(isAr ? arTitle : enTitle, isAr ? arDesc : enDesc);
  }, [i18n.language]);

  return (
    <div className="app-container">
      {/* <Header /> */}
      <HeroSection />
      <EmiratesIntroSection />
      <Vision2031Section />
      {/* <ObjectivesSection /> */}
      {/* <VisionMissionValuesSection /> */}
      <ManufacturersSection />
      <ProductsSection />
      <BenefitsSection />
      <LabelHowToSection />
      <StrategicPartnersShowcase />
      {/* <FeaturesSection />
      <NewsStoriesSection />
      <LatestEventsSection /> */}
      {/* <MembershipSection /> */}
      {/* <PartnersSection />
      <SocialFeedSection />
      <MembersCarouselSection />
      <ContactUsSection />
      <AcknowledgmentSection /> */}
      <FooterSection />
    </div>
  );
}

export default Home;



// import React, { useState } from 'react';
//  import { Box } from '@mui/material';
// //  import Footer from '../SharedLayout/Footer';
//  import { Footer, Header,FeatureCarousel,ImpactSection, ScrollingFeatures,ProfessionalFeaturesSection,  Subscriptions ,ContactForm, CirclePresentation } from './containers';
//  import CTASection from './containers/CTASection';

// // import Exercises from '../components/Exercises';
// // import SearchExercises from '../components/SearchExercises';
// // import HeroBanner from '../components/HeroBanner';
// const data={apple:1,mango:2,banana:3};

// const Home = () => {

//   return (

//     <div className="App">
//     <Header />

//     <ImpactSection />
//     <ScrollingFeatures />
//     <ProfessionalFeaturesSection />

//     {/* <CirclePresentation /> */}

//     <FeatureCarousel />
//     {/* <CTASection /> */}
//     <Subscriptions  />
//     <ContactForm/>
//     <Footer />
//   </div>
//   );
// };

// export default Home;
